<script setup>
import { useStore } from "vuex";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import de from 'element-plus/dist/locale/de.mjs'
import { computed } from "vue";

const store = useStore()

const currentLanguage = computed(() => store.getters.currentLanguage)

const local = computed(() => {
	// const lang = currentLanguage.value
	const lang = {
		cn: zhCn,
		en: en,
		de: de
	}
	return lang[currentLanguage.value]
})
</script>

<template>
	<div class="pagination">
		<el-config-provider :locale="local">
			<el-pagination
				v-bind="$attrs"
			/>
		</el-config-provider>
	</div>
</template>

<style scoped lang="less">
.pagination {
	::v-deep(.el-pagination) {
		.el-pager li.is-active {
			background-color: @primary-color;
			
			&:hover {
				color: #fff;
			}
		}
		
		.el-pager li:hover {
			color: #fff;
			background-color: @primary-color;
		}
		
		button:hover {
			color: @primary-color;
		}
	}
}
</style>